// extracted by mini-css-extract-plugin
export default {"address-select-button":"KlFCp","addressSelectButton":"KlFCp","title":"c4IlH","text":"X0C32","image":"UGbEE"};